import { LogoClock } from "#webapp/src/components/logo";
import * as React from "react";

export const AvatarLogo = ({ size }: { size: number }) => {
  const dimensions = {
    width: size || "100%",
    height: size || "100%",
  };

  return (
    <div
      style={dimensions}
      className="cw-flex cw-flex-shrink-0 cw-items-center cw-justify-center cw-text-onEmphasis cw-bg-accent-emphasis cw-relative cw-rounded-full"
    >
      <LogoClock size={size * 0.7} fill="bright" />
    </div>
  );
};
